import React ,{useState}from "react";
import Card from './Card';
import axios from 'axios';
import '../style/Api.scss';
import heroImage from '../Assets/bg1.png';
import { GOOGLE_BOOKS_API_KEY } from '../config';
const Main=()=>{
    const [search,setSearch]=useState("");
    const [bookData,setData]=useState([]);

    const fetchBooks = () => {
        const query = search.trim();
        if(!query) return;
        const encodedQuery = encodeURIComponent(query);
        axios.get(`https://www.googleapis.com/books/v1/volumes?q=${encodedQuery}&key=${GOOGLE_BOOKS_API_KEY}&maxResults=40`)
            .then(res=>setData(res.data.items))
            .catch(err=>console.log(err));
    };

    const searchBook=(evt)=>{
        if(evt.key==="Enter"){
            fetchBooks();
        }
    }
    return(
        <div className="bookstore-page">
            <div className="header">
                <div className="row1">
                    <h1>A room without books is like<br/> a body without a soul.</h1>
                </div>
                <div className="row2">
                    <h2>Find Your Book</h2>
                    <img src={heroImage} alt="Bookshelf with books" className="row2-image" />
                    <div className="search">
                        <input type="text" placeholder="Enter Your Book Name"
                        value={search} onChange={e=>setSearch(e.target.value)}
                        onKeyPress={searchBook}/>
                        <button type="button" onClick={fetchBooks} aria-label="Search books">
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="container">
              {
                    <Card book={bookData}/>
              }  
            </div>
        </div>
    )
}
export default Main;
